export function clearAllWidgetIframe() {
    document
        .querySelectorAll('.widgetScreen__container iframe')
        .forEach((i) => i.removeAttribute('src'));
}
